'use client';
import React, { useContext } from 'react';
import styles from './StickyCTA.module.css';

import { roundSessionCount } from '../../../utils/roundSessionCount';
import Dollar from '../../icons/Dollar';
import Star from '../../icons/Star';
import Button from '../../atoms/Button/Button';
import { OnePageCheckoutContext } from '@/providers/OnePageCheckout.provider';
import { calculateSessionCost } from '@/utils/calculateSessionCost';

interface IStickyCTAProps {
  hourly_rate: number;
  original_hourly_rate: number;
  mentor_slug: string;
  duration: number;
  rating: number;
  number_of_sessions: number;
  discount_code?: string;
}

const StickyCTAComponent = ({
  duration,
  hourly_rate,
  original_hourly_rate,
  mentor_slug,
  rating,
  number_of_sessions,
  discount_code,
}: IStickyCTAProps) => {
  const { toggleOpen } = useContext(OnePageCheckoutContext);

  const sessionCostResult = calculateSessionCost({
    duration: duration as 30 | 60,
    originalHourlyRate: original_hourly_rate,
    mentorSlug: mentor_slug,
    discountCode: discount_code,
  });

  return (
    <div className={styles.container}>
      <div className={styles.info}>
        <div className={styles.price}>
          <Dollar />
          <span>${sessionCostResult.finalCost} - </span>
          <p> {duration === 30 ? '30 minute call' : '1 hour call'}</p>
        </div>
        {number_of_sessions > 5 && (
          <div className={styles.rating}>
            <Star />
            <span>{rating.toFixed(1)}</span>
            <p>({roundSessionCount(number_of_sessions)} sessions)</p>
          </div>
        )}
      </div>
      <Button className={styles.button} onClick={toggleOpen}>
        Book Now
      </Button>
    </div>
  );
};

export default StickyCTAComponent;
